// helpers/units.js
export const mmToPx = (mm, dpi = 96) => (mm * dpi) / 25.4;
export const pxToMm = (px, dpi = 96) => (px * 25.4) / dpi;
